import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const routeSlice = createSlice({
  name: "route",
  initialState: { version: "1.0" },
  reducers: {
    setRoute(state, action) {
      return { ...state, ...action.payload };
    },
  },
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const { setRoute } = routeSlice.actions;
export const routeReducer = routeSlice.reducer;
